// extracted by mini-css-extract-plugin
module.exports = {"comp":"TabSwiper_comp__zNh5F","title":"TabSwiper_title__p3it3"};